import service from "@/store/services/tax-configuration-service";

export const state = () => ({
  config: {
    purchases: [],
    sales: [],
    chargesRates: {},
  },
});

export const mutations = {
  SET_CONFIG: (state, config) => {
    state.config = config;
  },
};

export const actions = {
  get({ commit }) {
    return service.get().then((response) => {
      const data = response?.data || {};
      const meta = response?.meta || {};
      commit("SET_CONFIG", {
        purchases: data.purchases || [],
        sales: data.sales || [],
        chargesRates: meta.charges_tax_rates || {},
      });
      return response;
    });
  },
};

const getters = {
  config: (state) => state.config,
  purchases: (state) => state.config.purchases,
  sales: (state) => state.config.sales,
  chargesRates: (state) => state.config.chargesRates,
};

const taxConfiguration = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default taxConfiguration;
